import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL


class PaymentApi {
    getPaymentDetailsById(userId, config) {
        return axios.post(`${baseUrl}/admin/payment/userPaymentHistory`, { userId }, config)
    }
    //payment page transcation part
    getMetaData(config) {
        return axios.get(`${baseUrl}/admin/payment/paymentMetaData`, config)
    }

    getPaymentHistory(config) {
        return axios.get(`${baseUrl}/admin/payment/paymentHistory`, config)
    }


    //ticket page
    getTicketHistory(config) {
        return axios.get(`${baseUrl}/admin/payment/ticketHistory`, config)
    }

    updateTicketStatus(ticketId, status, config) {
        return axios.put(`${baseUrl}/admin/payment/ticketStatus`, {
            ticketId,
            status
        }, config)
    }


    //Request page

    getPaymentRequest(config) {
        return axios.get(`${baseUrl}/admin/payment/payment-request`, config)
    }

    confirmPayment(userId, amount, reason, transactionId, config) {
        return axios.put(`${baseUrl}/admin/payment/confirm-payment`, {
            userId,
            amount,
            reason,
            transactionId
        }, config)
    }


    //kyc page
    getKycDetails(config) {
        return axios.get(`${baseUrl}/admin/payment/kycDetails`, config)
    }

    verifyKycDocument(userId, documentType, remarks, config) {
        return axios.put(`${baseUrl}/admin/payment/verify-kyc-document`, {
            userId,
            documentType,
            remarks
        }, config)
    }

    verifyKycStatus(userId, config) {
        return axios.put(`${baseUrl}/admin/payment/verify-kyc-status`, {
            userId
        }, config)
    }



}

const paymentApi = new PaymentApi()
export default paymentApi